import React, { Component } from 'react'
import { connect } from 'react-redux'
import Modal from 'react-modal'

import BkFlowRoomCardNightlyRates from '../BkFlowRoomCardNightlyRates'
import BkFlowRoomCardRateStagePriceDetails from './BkFlowRoomCardRateStagePriceDetails'
import BkFlowRoomCardRateStagePriceButtonCondensed from './BkFlowRoomCardRateStagePriceButtonCondensed'
import BkFlowRoomCardRateStagePriceButtonWide from './BkFlowRoomCardRateStagePriceButtonWide'
import BkFlowRoomCardRateStagePriceButtonColumns from './BkFlowRoomCardRateStagePriceButtonColumns'

import getCurrencySymbol from '../../../../utilities/currency/getCurrencySymbol'
import getCombinedTaxesFeesTotal from '../../../../utilities/currency/getCombinedTaxesFeesTotal'

import fetchRoomRateDetails from '../../../../actions/fetchRoomRateDetails'

import Collapse from '@material-ui/core/Collapse'

import moment from 'moment/moment'
import yn from 'yn'
import _ from 'lodash'

import parseValidHtmlString from '../../../../utilities/content/parseValidHtmlString'
import renderHtml from 'react-render-html'
import triggerCustomGaEvent from '../../../../utilities/analytics/triggerCustomGaEvent'
import dateFormats from '../../../../utilities/dates/dateFormats'

class BkFlowRoomCardRateStagePriceButton extends Component {
	constructor(props) {
		super(props)
		this.state = {
			rateDetailsExpanded: false,
		}
	}

	toggleRateDetails = () => {
		const {
			roomGroup,
			roomRateData,
			handleFetchRatePlanDetails,
			roomRateDetailsData
		} = this.props

		this.setState({
			rateDetailsExpanded: !this.state.rateDetailsExpanded
		})

		// Dispatch adaDescription GA events
		const multiStageRateDetailsData = {
			roomType: roomRateData.roomTypeCode,
			ratePlan: roomRateData.ratePlanCode,
			expanded: !this.state.rateDetailsExpanded
		}

		triggerCustomGaEvent('analytics-multiStageRatesDetailsView', multiStageRateDetailsData)

		// Fetch additional rate details not included in avail-rooms as needed VIA env config
		if (yn(process.env.REACT_APP_COMPONENT_ENABLE_FETCH_RATE_DETAILS)) {
			let fetchRateDetails = true

			if (
				roomRateDetailsData &&
				roomRateDetailsData.roomRateDetails &&
				roomRateDetailsData.roomRateDetails[roomRateData.roomTypeCode + '-' + roomRateData.ratePlanCode + '-' + roomGroup]
			) {
				fetchRateDetails = false
			}

			if (
				roomRateData.roomTypeCode &&
				roomRateData.ratePlanCode &&
				fetchRateDetails
			) {
				handleFetchRatePlanDetails(roomGroup, roomRateData.roomTypeCode, roomRateData.ratePlanCode)
			}
		}
	}

	render() {
		const {
			activeCurrencyData,
			availabilityData,
			configData,
			currentUpSells,
			featuredRatePlans,
			isCollectionRate,
			isTaxInclusiveProperty,
			ratePlanData,
			roomGroup,
			roomRateData,
			roomRateDetailsData,
			toggleActiveRoom,
			totalNights,
			urlData,
			upSellsToggleEvent
		} = this.props

		const { rateDetailsExpanded } = this.state
		const hotelLabels = configData.hotel.labels[0]
		const addTotals = (a, b) => a + b

		let activeHotelCode = null
		let matchedProperty = null
		let displayedPriceFrequency = 'per stay'
		let rateBeforeDiscount = null
		let roomRateDiscountData = []
		let roomRatePrice = null
		let rateTaxesFeesTotal = null
		let rateTaxesTotal = null
		let rateFeesTotal = null
		let rateDestinationFeeCode = null
		let rateDestinationFeeAmount = null
		let rateDestinationFeeCurrencyCode = 'USD'
		let rateDestinationFeeCurrencySymbol = getCurrencySymbol(rateDestinationFeeCurrencyCode)
		let rateDestinationFeeLabel = null
		let rateDestinationFeeFrequency = null
		let rateCurrencyCode = _.get(roomRateData, 'rates[0].total.currencyCode', '')
		let rateCurrencySymbol = getCurrencySymbol(rateCurrencyCode)
		let ratePlanName = null
		let ratePlanDescription = null
		let ratePlanDescriptionExtended = null
		let rateCancelDeadline = null
		let ratePlanCancelPolicy = null
		let ratePlanGuaranteePolicy = _.get(roomRateData.rates, '[0].paymentPolicies[0].description.text', null)
		let isLoyaltyRate = false
		let renderNightlyRates = null
		let roomRatePlanId = null
		let partnerRateData = null
		let isFeaturedRate = _.includes(featuredRatePlans, roomRateData.ratePlanCode)

		const ratePlanImage = _.get(ratePlanData, 'viewExtensions.ratePlanImage', null)

		if (
			!_.isEmpty(urlData) &&
			urlData.hotelCode
		) {
			activeHotelCode = urlData.hotelCode
		}

		if (!_.isEmpty(configData)) {
			const configProperties = configData.hotel.options.properties

			matchedProperty = configProperties.find(function (property) {
				return property.hotelCode === String(activeHotelCode)
			})
		}

		if (matchedProperty) {
			if (matchedProperty.displayPricesTimeline) {
				displayedPriceFrequency = matchedProperty.displayPricesTimeline
			}
		}

		// Calculated exchange format for daily price symbol and code
		if (
			yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
			activeCurrencyData &&
			activeCurrencyData.exchangeRate &&
			activeCurrencyData.currencyCode
		) {
			rateCurrencyCode = activeCurrencyData.currencyCode

			if (activeCurrencyData.currencySymbol) {
				rateCurrencySymbol = activeCurrencyData.currencySymbol
			} else {
				rateCurrencySymbol = getCurrencySymbol(activeCurrencyData.currencyCode)
			}
		}

		// Set rate plan name
		if (
			ratePlanData &&
			ratePlanData.ratePlanName &&
			!isCollectionRate
		) {
			ratePlanName = ratePlanData.ratePlanName
		}

		if (
			ratePlanData &&
			ratePlanData.viewExtensions &&
			ratePlanData.viewExtensions.extendedRatePlanDescriptionText
		) {
			ratePlanDescriptionExtended = renderHtml(ratePlanData.viewExtensions.extendedRatePlanDescriptionText)
		}

		if (
			ratePlanData &&
			ratePlanData.ratePlanDescription &&
			ratePlanData.ratePlanDescription.text !== ''
		) {
			ratePlanDescription = parseValidHtmlString(ratePlanData.ratePlanDescription.text)
		}

		// Set rate plan cancel fee and deadline
		if (
			roomRateData &&
			roomRateData.rates &&
			_.get(roomRateData.rates, '[0].cancelPolicies') &&
			!_.isEmpty(roomRateData.rates[0].cancelPolicies)
		) {
			const cancellationRules = roomRateData.rates[0].cancelPolicies[0]
			if (
				cancellationRules.deadline &&
				cancellationRules.deadline.absoluteDeadline
			) {
				rateCancelDeadline = moment(new Date(cancellationRules.deadline.absoluteDeadline)).format('MMM Do, Y')
			}

			if (
				cancellationRules.penaltyDescription &&
				cancellationRules.penaltyDescription.text
			) {
				ratePlanCancelPolicy = cancellationRules.penaltyDescription.text
			}
		} else if (
			roomRateData.roomTypeCode &&
			roomRateData.ratePlanCode &&
			roomRateDetailsData &&
			roomRateDetailsData.roomRateDetails &&
			roomRateDetailsData.roomRateDetails[roomRateData.roomTypeCode + '-' + roomRateData.ratePlanCode + '-' + roomGroup] &&
			roomRateDetailsData.roomRateDetails[roomRateData.roomTypeCode + '-' + roomRateData.ratePlanCode + '-' + roomGroup].rates &&
			roomRateDetailsData.roomRateDetails[roomRateData.roomTypeCode + '-' + roomRateData.ratePlanCode + '-' + roomGroup].rates[0] &&
			!_.isEmpty(roomRateDetailsData.roomRateDetails[roomRateData.roomTypeCode + '-' + roomRateData.ratePlanCode + '-' + roomGroup].rates[0].cancelPolicies)
		) {
			const cancellationRules = roomRateDetailsData.roomRateDetails[roomRateData.roomTypeCode + '-' + roomRateData.ratePlanCode + '-' + roomGroup].rates[0].cancelPolicies[0]

			if (
				cancellationRules.deadline &&
				cancellationRules.deadline.absoluteDeadline
			) {
				rateCancelDeadline = moment(new Date(cancellationRules.deadline.absoluteDeadline)).format(dateFormats.roomRateCancellationDeadline)
			}

			if (cancellationRules.penaltyDescription.text) {
				ratePlanCancelPolicy = cancellationRules.penaltyDescription.text
			}
		}

		if (
			roomRateData.roomTypeCode &&
			roomRateData.ratePlanCode &&
			roomRateDetailsData &&
			roomRateDetailsData.roomRateDetails &&
			roomRateDetailsData.roomRateDetails[roomRateData.roomTypeCode + '-' + roomRateData.ratePlanCode + '-' + roomGroup] &&
			roomRateDetailsData.roomRateDetails[roomRateData.roomTypeCode + '-' + roomRateData.ratePlanCode + '-' + roomGroup].rates &&
			roomRateDetailsData.roomRateDetails[roomRateData.roomTypeCode + '-' + roomRateData.ratePlanCode + '-' + roomGroup].rates[0] &&
			!_.isEmpty(roomRateDetailsData.roomRateDetails[roomRateData.roomTypeCode + '-' + roomRateData.ratePlanCode + '-' + roomGroup].rates[0].paymentPolicies)
		) {
			const guaranteePolicyDetails = roomRateDetailsData.roomRateDetails[roomRateData.roomTypeCode + '-' + roomRateData.ratePlanCode + '-' + roomGroup].rates[0].paymentPolicies[0]

			if (
				guaranteePolicyDetails.description &&
				guaranteePolicyDetails.description.text &&
				guaranteePolicyDetails.description.text !== ''
			) {
				ratePlanGuaranteePolicy = guaranteePolicyDetails.description.text
			}
		}

		let isMembersRate = false

		if (roomRateData.ratePlanType === 'MEMBER') {
			isMembersRate = true
		}

		// Init tax total & line items
		if (
			roomRateData.viewExtensions &&
			roomRateData.viewExtensions.resortDestinationFeeCode &&
			roomRateData.viewExtensions.resortDestinationFeeCode !== ''
		) {
			rateDestinationFeeCode = roomRateData.viewExtensions.resortDestinationFeeCode
		}

		rateTaxesFeesTotal = getCombinedTaxesFeesTotal(roomRateData)

		if (
			rateTaxesFeesTotal !== null &&
			yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
			activeCurrencyData &&
			activeCurrencyData.exchangeRate
		) {
			rateTaxesFeesTotal = rateTaxesFeesTotal * activeCurrencyData.exchangeRate
		}

		if (
			roomRateData &&
			roomRateData.rates &&
			_.get(roomRateData.rates, '[0].total.taxes')
		) {
			// Init tax total by CRS * Exchange or CRS only
			if (roomRateData.rates[0].total.taxes.amount) {
				if (
					yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
					activeCurrencyData &&
					activeCurrencyData.exchangeRate
				) {
					rateTaxesTotal = roomRateData.rates[0].total.taxes.amount * activeCurrencyData.exchangeRate
				} else {
					rateTaxesTotal = roomRateData.rates[0].total.taxes.amount
				}
			}

			// Map destinationFeeCode to correct fee data for price & currency
			if (
				!_.isEmpty(roomRateData.rates[0].total.taxes.tax) &&
				rateDestinationFeeCode
			) {
				const rateDestinationFeeData = roomRateData.rates[0].total.taxes.tax.filter(function(taxFee) {
					return taxFee.code === rateDestinationFeeCode
				})

				if (
					rateDestinationFeeData[0] &&
					rateDestinationFeeData[0].amount
				) {
					if (
						yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
						activeCurrencyData &&
						activeCurrencyData.exchangeRate
					) {
						rateDestinationFeeAmount = rateDestinationFeeData[0].amount * activeCurrencyData.exchangeRate
					} else {
						rateDestinationFeeAmount = rateDestinationFeeData[0].amount
					}
				}

				if (
					rateDestinationFeeData[0] &&
					rateDestinationFeeData[0].currencyCode !== ''
				) {
					rateDestinationFeeCurrencyCode = rateDestinationFeeData[0].currencyCode
					rateDestinationFeeCurrencySymbol = getCurrencySymbol(rateDestinationFeeCurrencyCode)

					if (
						yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
						activeCurrencyData &&
						activeCurrencyData.exchangeRate &&
						activeCurrencyData.currencyCode
					) {
						rateDestinationFeeCurrencyCode = activeCurrencyData.currencyCode

						if (activeCurrencyData.currencySymbol) {
							rateDestinationFeeCurrencySymbol = activeCurrencyData.currencySymbol
						} else {
							rateDestinationFeeCurrencySymbol = getCurrencySymbol(activeCurrencyData.currencyCode)
						}
					}
				}

				if (
					rateDestinationFeeData[0] &&
					rateDestinationFeeData[0].chargeFrequency
				) {
					rateDestinationFeeFrequency = rateDestinationFeeData[0].chargeFrequency
				}

				if (
					rateDestinationFeeData[0] &&
					rateDestinationFeeData[0].taxDescription
				) {
					let currentLabel = null

					for (const descriptionKey in rateDestinationFeeData[0].taxDescription) {
						const currentFeeDescription = rateDestinationFeeData[0].taxDescription[descriptionKey]

						if (currentFeeDescription.name === 'Name') {
							currentLabel = currentFeeDescription.text
						}
					}

					rateDestinationFeeLabel = currentLabel
				}
			}
		}

		// Set room fees total via room rate viewExtensions
		if (_.get(roomRateData.rates, '[0].total.viewExtensions.fees.amount')) {

			if (
				yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
				activeCurrencyData &&
				activeCurrencyData.exchangeRate
			) {
				rateFeesTotal = roomRateData.rates[0].total.viewExtensions.fees.amount * activeCurrencyData.exchangeRate
			} else {
				rateFeesTotal = roomRateData.rates[0].total.viewExtensions.fees.amount
			}
		}

		// Set loyalty rate flag from API
		if (roomRateData.isLoyaltyRate) {
			isLoyaltyRate = roomRateData.isLoyaltyRate
		}

		const feeTotalBeforeCalculations = _.get(roomRateData.rates, '[0].total.viewExtensions.fees.amount') || 0
		// enable front end exchange rate calculations
		if (
			yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
			activeCurrencyData &&
			activeCurrencyData.exchangeRate
		) {
			if (displayedPriceFrequency === 'per stay') {
				if (isTaxInclusiveProperty) {
					roomRatePrice = roomRateData.rates[0].total.amountAfterTax * activeCurrencyData.exchangeRate
				} else {
					roomRatePrice = (roomRateData.rates[0].total.amountBeforeTax + feeTotalBeforeCalculations) * activeCurrencyData.exchangeRate
				}
			} else {
				if (isTaxInclusiveProperty) {
					roomRatePrice = roomRateData.rates[0].total.amountAfterTax / totalNights * activeCurrencyData.exchangeRate
				} else {
					roomRatePrice = (roomRateData.rates[0].total.amountBeforeTax + feeTotalBeforeCalculations) / totalNights * activeCurrencyData.exchangeRate
				}
			}
		} else if (displayedPriceFrequency === 'per stay') {
			// Set average rate to nightly or total based on env
			if (isTaxInclusiveProperty) {
				roomRatePrice = roomRateData.rates[0].total.amountAfterTax
			} else {
				roomRatePrice = roomRateData.rates[0].total.amountBeforeTax + feeTotalBeforeCalculations
			}
		} else {
			if (isTaxInclusiveProperty) {
				roomRatePrice = roomRateData.rates[0].total.amountAfterTax / totalNights
			} else {
				roomRatePrice = (roomRateData.rates[0].total.amountBeforeTax + feeTotalBeforeCalculations) / totalNights
			}
		}

		// Combine discount line items into a single total
		if (
			roomRateData.discounts &&
			!_.isEmpty(roomRateData.discounts)
		) {
			for (const discountKey in roomRateData.discounts) {
				const currentDiscount = roomRateData.discounts[discountKey]
				roomRateDiscountData.push(currentDiscount.amountBeforeTax)
			}
		}

		// Calculate rate before discount
		if (
			roomRatePrice > 0 &&
			!_.isEmpty(roomRateDiscountData)
		) {

			// Default rate before discount (average nightly rate)
			rateBeforeDiscount = roomRateDiscountData.reduce(addTotals) + roomRatePrice / totalNights

			// Calculate rate by total amount before tax
			if (displayedPriceFrequency === 'per stay') {
				rateBeforeDiscount = roomRateDiscountData.reduce(addTotals) + roomRatePrice

				// Enable front-end FOREX conversion on total amount
				if (
					yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
					activeCurrencyData &&
					activeCurrencyData.exchangeRate
				) {
					rateBeforeDiscount = roomRateDiscountData.reduce(addTotals) + roomRatePrice * activeCurrencyData.exchangeRate
				}
			} else if (
				yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
				activeCurrencyData &&
				activeCurrencyData.exchangeRate
			) {
				// Enable front-end FOREX conversion on average nightly amount
				rateBeforeDiscount = roomRateDiscountData.reduce(addTotals) + roomRatePrice / totalNights * activeCurrencyData.exchangeRate
			}
		}

		if (
			roomRateData &&
			roomRateData.viewExtensions &&
			!_.isEmpty(roomRateData.viewExtensions.nightlyRates)
		) {
			renderNightlyRates = (
				<BkFlowRoomCardNightlyRates
					configData={configData}
					activeCurrencyData={activeCurrencyData}
					roomRateData={roomRateData}
					rateCurrencyCode={rateCurrencyCode}
					rateCurrencySymbol={rateCurrencySymbol}
				/>
			)
		} else if (
			roomRateData.roomTypeCode &&
			roomRateData.ratePlanCode &&
			roomRateDetailsData &&
			roomRateDetailsData.roomRateDetails &&
			roomRateDetailsData.roomRateDetails[roomRateData.roomTypeCode + '-' + roomRateData.ratePlanCode + '-' + roomGroup] &&
			yn(process.env.REACT_APP_COMPONENT_ENABLE_FETCH_RATE_DETAILS)
		) {
			renderNightlyRates = (
				<BkFlowRoomCardNightlyRates
					configData={configData}
					activeCurrencyData={activeCurrencyData}
					roomRateData={roomRateDetailsData.roomRateDetails[roomRateData.roomTypeCode + '-' + roomRateData.ratePlanCode + '-' + roomGroup]}
					rateCurrencyCode={rateCurrencyCode}
					rateCurrencySymbol={rateCurrencySymbol}
				/>
			)
		}

		// Render Partners Branding
		if (
			yn(process.env.REACT_APP_COMPONENT_PARTNERS_RATE_BRANDING) &&
			roomRateData &&
			roomRateData.viewExtensions &&
			roomRateData.viewExtensions.ratePlanId
		) {
				roomRatePlanId = roomRateData.viewExtensions.ratePlanId

			if (String(urlData.promoCode) === String(roomRatePlanId)) {
				if (
					availabilityData &&
					_.get(availabilityData, '[0][0].basicPropertyInfo.viewExtensions.partners')
				) {
					const currentPartnersData = availabilityData[0][0].basicPropertyInfo.viewExtensions.partners.filter(function(partner) {
						return partner.ratePlanId === roomRatePlanId
					})

					partnerRateData = currentPartnersData[0]
				}
			}
		}

		const roomRateDetailsKey = `${_.get(roomRateData, 'roomTypeCode')}-${_.get(roomRateData, 'ratePlanCode')}-${roomGroup}`
		const roomRateDetailsPolicies = _.get(roomRateDetailsData, `roomRateDetails[${roomRateDetailsKey}].viewExtensions.policies`)

		return (
			<div
				className={`bk-flow-room__price-col${ isFeaturedRate ? ' featured-rate' : ''}`}
				id={'bk-flow-room__rate-' + roomGroup + '-' + roomRateData.roomTypeCode + '-' + roomRateData.ratePlanCode }
			>
				{ process.env.REACT_APP_COMPONENT_ROOM_RATE_STAGE_BUTTON_LAYOUT ==='wide' ?
					<BkFlowRoomCardRateStagePriceButtonWide
						currentUpSells={currentUpSells}
						displayedPriceFrequency={displayedPriceFrequency}
						isLoyaltyRate={isLoyaltyRate}
						isMembersRate={isMembersRate}
						partnerRateData={partnerRateData}
						rateCurrencyCode={rateCurrencyCode}
						rateCurrencySymbol={rateCurrencySymbol}
						rateDestinationFeeAmount={rateDestinationFeeAmount}
						rateDestinationFeeCurrencyCode={rateDestinationFeeCurrencyCode}
						rateDestinationFeeCurrencySymbol={rateDestinationFeeCurrencySymbol}
						rateDestinationFeeFrequency={rateDestinationFeeFrequency}
						rateDestinationFeeLabel={rateDestinationFeeLabel}
						rateDetailsExpanded={rateDetailsExpanded}
						rateFeesTotal={rateFeesTotal}
						ratePlanCancelPolicy={ratePlanCancelPolicy}
						ratePlanGuaranteePolicy={ratePlanGuaranteePolicy}
						ratePlanName={ratePlanName}
						ratePlanDescription={ratePlanDescription}
						ratePlanDescriptionExtended={ratePlanDescriptionExtended}
						ratePlanImage={ratePlanImage}
						rateTaxesFeesTotal={rateTaxesFeesTotal}
						rateTaxesTotal={rateTaxesTotal}
						roomGroup={roomGroup}
						roomRateData={roomRateData}
						roomRatePrice={roomRatePrice}
						toggleActiveRoom={toggleActiveRoom}
						toggleRateDetails={() => this.toggleRateDetails()}
						upSellsToggleEvent={upSellsToggleEvent}
					/>
				: process.env.REACT_APP_COMPONENT_ROOM_RATE_STAGE_BUTTON_LAYOUT ==='columns' ?
						<BkFlowRoomCardRateStagePriceButtonColumns
							currentUpSells={currentUpSells}
							displayedPriceFrequency={displayedPriceFrequency}
							isLoyaltyRate={isLoyaltyRate}
							isMembersRate={isMembersRate}
							partnerRateData={partnerRateData}
							rateCurrencyCode={rateCurrencyCode}
							rateCurrencySymbol={rateCurrencySymbol}
							rateDestinationFeeAmount={rateDestinationFeeAmount}
							rateDestinationFeeCurrencyCode={rateDestinationFeeCurrencyCode}
							rateDestinationFeeCurrencySymbol={rateDestinationFeeCurrencySymbol}
							rateDestinationFeeFrequency={rateDestinationFeeFrequency}
							rateDestinationFeeLabel={rateDestinationFeeLabel}
							rateDetailsExpanded={rateDetailsExpanded}
							rateFeesTotal={rateFeesTotal}
							ratePlanCancelPolicy={ratePlanCancelPolicy}
							ratePlanGuaranteePolicy={ratePlanGuaranteePolicy}
							ratePlanName={ratePlanName}
							ratePlanDescription={ratePlanDescription}
							ratePlanDescriptionExtended={ratePlanDescriptionExtended}
							rateTaxesFeesTotal={rateTaxesFeesTotal}
							rateTaxesTotal={rateTaxesTotal}
							roomGroup={roomGroup}
							roomRateData={roomRateData}
							roomRatePrice={roomRatePrice}
							toggleActiveRoom={toggleActiveRoom}
							toggleRateDetails={() => this.toggleRateDetails()}
							upSellsToggleEvent={upSellsToggleEvent}
						/>
					:
					<BkFlowRoomCardRateStagePriceButtonCondensed
						currentUpSells={currentUpSells}
						displayedPriceFrequency={displayedPriceFrequency}
						isLoyaltyRate={isLoyaltyRate}
						isMembersRate={isMembersRate}
						isTaxInclusiveProperty={isTaxInclusiveProperty}
						partnerRateData={partnerRateData}
						rateBeforeDiscount={rateBeforeDiscount}
						rateCancelDeadline={rateCancelDeadline}
						rateCurrencyCode={rateCurrencyCode}
						rateCurrencySymbol={rateCurrencySymbol}
						rateDestinationFeeAmount={rateDestinationFeeAmount}
						rateDestinationFeeCurrencyCode={rateDestinationFeeCurrencyCode}
						rateDestinationFeeCurrencySymbol={rateDestinationFeeCurrencySymbol}
						rateDestinationFeeFrequency={rateDestinationFeeFrequency}
						rateDestinationFeeLabel={rateDestinationFeeLabel}
						rateDetailsExpanded={rateDetailsExpanded}
						rateFeesTotal={rateFeesTotal}
						ratePlanData={ratePlanData}
						ratePlanName={ratePlanName}
						rateTaxesFeesTotal={rateTaxesFeesTotal}
						rateTaxesTotal={rateTaxesTotal}
						roomGroup={roomGroup}
						roomRateData={roomRateData}
						roomRatePrice={roomRatePrice}
						toggleActiveRoom={toggleActiveRoom}
						toggleRateDetails={() => this.toggleRateDetails()}
						upSellsToggleEvent={upSellsToggleEvent}
					/>
				}


				{ process.env.REACT_APP_COMPONENT_ROOM_RATE_DETAILS_COMPONENT === 'modal' ?
					<Modal
						className={{
							base: 'bk-flow-room__price-details-modal u-modal u-modal--sm',
							afterOpen: 'u-modal--visible',
							beforeClose: 'u-modal--close',
							ariaHideApp: false
						}}
						overlayClassName={{
							base: 'u-fade',
							afterOpen: 'u-fade--visible',
							beforeClose: 'u-fade--visible'
						}}
						isOpen={ rateDetailsExpanded }
						onRequestClose={ () => this.toggleRateDetails() }
						contentLabel="Room Rate Details Modal"
						shouldCloseOnOverlayClick={ true }
						ariaHideApp={ false }
					>
						{ratePlanName &&
							<div className="u-modal__header">
								<h5>{ ratePlanName }</h5>

								<div
									className="u-modal__close u-font-small u-font-bold"
									onClick={ () => this.toggleRateDetails() }
								>
									{ hotelLabels.close ? hotelLabels.close : 'Close' }
									<i className="material-icons">close</i>
								</div>
							</div>
						}
						<div className="u-modal__body">
							<BkFlowRoomCardRateStagePriceDetails
								activeCurrencyData={activeCurrencyData}
								availabilityData={availabilityData}
								configData={configData}
								hotelLabels={hotelLabels}
								partnerRateData={partnerRateData}
								rateCurrencyCode={rateCurrencyCode}
								rateCurrencySymbol={rateCurrencySymbol}
								ratePlanCancelPolicy={ratePlanCancelPolicy}
								ratePlanGuaranteePolicy={ratePlanGuaranteePolicy}
								ratePlanDescription={ratePlanDescription}
								ratePlanDescriptionExtended={ratePlanDescriptionExtended}
								renderNightlyRates={renderNightlyRates}
								roomRateData={roomRateData}
								roomRateDetailsData={roomRateDetailsData}
							/>
						</div>
					</Modal>
				:
					<Collapse
						in={ rateDetailsExpanded }
						timeout={ 300 }
					>
						<BkFlowRoomCardRateStagePriceDetails
							activeCurrencyData={activeCurrencyData}
							availabilityData={availabilityData}
							configData={configData}
							hotelLabels={hotelLabels}
							partnerRateData={partnerRateData}
							policies={roomRateDetailsPolicies}
							rateCurrencyCode={rateCurrencyCode}
							rateCurrencySymbol={rateCurrencySymbol}
							ratePlanCancelPolicy={ratePlanCancelPolicy}
							ratePlanGuaranteePolicy={ratePlanGuaranteePolicy}
							ratePlanDescription={ratePlanDescription}
							ratePlanDescriptionExtended={ratePlanDescriptionExtended}
							renderNightlyRates={renderNightlyRates}
							roomRateData={roomRateData}
							roomRateDetailsData={roomRateDetailsData}
						/>
					</Collapse>
				}
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration,
		availabilityData: state.availabilityData.availability,
		roomRateDetailsData: state.roomRateDetailsData,
		urlData: state.availabilityData.urlData,
	}
}

const mapDispatchToProps = dispatch => ({
	handleFetchRatePlanDetails(roomGroup, roomTypeCode, ratePlanCode) {
		return dispatch(fetchRoomRateDetails(roomGroup, roomTypeCode, ratePlanCode))
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(BkFlowRoomCardRateStagePriceButton)


// WEBPACK FOOTER //
// ./src/components/room/elements/multi-stage/BkFlowRoomCardRateStagePriceButton.js